export default __webpack_public_path__ + "static/media/group-581@2x.b0abb9cc.png";